import {
    ACTION_OBJECTLIST_SUCCESS,
    } from './action';
    import createReducer from '../../../../reducers/createReducer';
    
    const INITIAL_STATE = {
            data: [],
            loading: false
        };
    
    const ObjectListReducer = createReducer(
        INITIAL_STATE,
        {
         [ACTION_OBJECTLIST_SUCCESS](state, action) {
            return {
              ...state,
              data: action.payload.data,
              tag: ACTION_OBJECTLIST_SUCCESS,
              loading: false
            };
          },
        }
    );
    export default ObjectListReducer;